import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconDone from '@/icons/Done.svg';

/**
 *
 * Informative message about articles handling, displayed in client and store views, on top of articles and other information
 */
export const StepMessage = ({
  message,
  iconDone = false,
}: {
  message: React.ReactNode;
  iconDone?: boolean;
}) => {
  return (
    <Stack row gap="0.5rem" alignItems="center" flexWrap="nowrap">
      {iconDone && <IconDone style={{ fontSize: '1.5rem' }} className="text-success" />}

      <Paragraph size="50" color="secondary">
        {message}
      </Paragraph>
    </Stack>
  );
};
